import { useMutation, useQuery } from 'urql';
import PageHeader from '@/components/common/PageHeader.jsx';
import StickyActions from '@/components/common/StickyActions.jsx';
import { GET_SLA, ACTIVAR_SLA } from './gql.js';

export default function SlaDetail({ slaId, onBack, onEdit }) {
  const [{ data, fetching, error }] = useQuery({ query: GET_SLA, variables: { id: slaId } });
  const [, activarSla] = useMutation(ACTIVAR_SLA);

  const sla = data?.getSLA;

  const handleToggle = async () => {
    const result = await activarSla({ id: slaId, activo: !sla?.activo });
    if (result.error) {
      alert(result.error.message);
    }
  };

  return (
    <div className="w-full">
      <PageHeader
        title={sla ? sla.nombre : 'Detalle SLA'}
        subtitle={sla ? `Promesa ${sla.promesaHoras}h · 1ª respuesta ${sla.primeraRespuestaMin} min` : ''}
        actions={(
          <div className="flex gap-3">
            <button
              type="button"
              onClick={() => onEdit?.(slaId)}
              className="rounded-xl border border-[rgba(var(--border),0.6)] px-4 py-2 text-sm font-semibold text-[rgb(var(--fg))] transition hover:bg-[rgba(var(--subpanel),0.6)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            >
              Editar
            </button>
            <button
              type="button"
              onClick={onBack}
              className="rounded-xl bg-[rgb(var(--brand))] px-4 py-2 text-sm font-semibold text-white shadow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))]"
            >
              Volver
            </button>
          </div>
        )}
      />

      <section className="mx-auto mt-6 w-full max-w-[800px] rounded-2xl border border-[rgba(var(--border),0.6)] bg-[rgba(var(--panel),0.98)] p-6 shadow-xl">
        {fetching ? (
          <p className="text-sm text-[rgba(var(--muted),0.9)]">Cargando...</p>
        ) : error ? (
          <p className="text-sm text-rose-500">{error.message}</p>
        ) : sla ? (
          <dl className="grid grid-cols-2 gap-4 text-sm text-[rgba(var(--muted),0.95)]">
            <div>
              <dt className="font-semibold text-[rgb(var(--fg))]">Tipo servicio</dt>
              <dd>{sla.tipoServicio}</dd>
            </div>
            <div>
              <dt className="font-semibold text-[rgb(var(--fg))]">Zona</dt>
              <dd>{sla.zona || 'Todas'}</dd>
            </div>
            <div>
              <dt className="font-semibold text-[rgb(var(--fg))]">Promesa</dt>
              <dd>{sla.promesaHoras} h</dd>
            </div>
            <div>
              <dt className="font-semibold text-[rgb(var(--fg))]">1ª respuesta</dt>
              <dd>{sla.primeraRespuestaMin} min</dd>
            </div>
            <div>
              <dt className="font-semibold text-[rgb(var(--fg))]">Creado</dt>
              <dd>{new Date(sla.creadoEn).toLocaleString()}</dd>
            </div>
            <div>
              <dt className="font-semibold text-[rgb(var(--fg))]">Actualizado</dt>
              <dd>{new Date(sla.actualizadoEn).toLocaleString()}</dd>
            </div>
          </dl>
        ) : (
          <p className="text-sm text-[rgba(var(--muted),0.9)]">SLA no encontrado.</p>
        )}
        {sla ? (
          <button
            type="button"
            onClick={handleToggle}
            className={`mt-6 rounded-xl px-4 py-2 text-sm font-semibold transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[rgb(var(--ring))] ${sla.activo ? 'bg-emerald-500/20 text-emerald-500' : 'bg-slate-500/20 text-slate-500'}`}
          >
            {sla.activo ? 'Desactivar' : 'Activar'}
          </button>
        ) : null}
      </section>

      <StickyActions>
        <div className="flex w-full items-center justify-between text-xs text-[rgba(var(--muted),0.9)]">
          <span>ID: {slaId}</span>
          <span>Estado: {sla?.activo ? 'Activo' : 'Inactivo'}</span>
        </div>
      </StickyActions>
    </div>
  );
}
